import { render, staticRenderFns } from "./PurchaseDirectBuyArticles.vue?vue&type=template&id=39269d4b"
import script from "./PurchaseDirectBuyArticles.vue?vue&type=script&lang=js"
export * from "./PurchaseDirectBuyArticles.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDirectBuyArticles.vue?vue&type=style&index=0&id=39269d4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports